import { HttpParams } from '@angular/common/http';
import { TasksListGetQueryParamsInterface } from './definitions/tasks-list-get-query-params.interface';

export function createQueryParams(paramsObj: TasksListGetQueryParamsInterface): HttpParams {
  let params: HttpParams = new HttpParams();

  params = params.set('page', paramsObj.Page.toString());

  params = params.set('pageSize', paramsObj.PageSize.toString());

  if (paramsObj.Status !== null) {
    params = params.set('status', paramsObj.Status);
  }

  if(paramsObj.Search !== null) {
    params = params.append('search', paramsObj.Search);
  }

  return params;
}
